import { FC, useMemo } from "react";
import { useEquipment } from "api/hooks";
import { addHours, format } from "date-fns";
import { useSearchParams } from "react-router-dom";

import { CircularProgress, Grid2 } from "@mui/material";

import { Category } from "../../../../api/hooks/useEquipment/type.ts";
import { convertStingToDate } from "../../TimeSelectionForm/components/ControlledCalendar.tsx";

import ControlledEquipmentSelectionCheckboxGroup, {
  ControlledEquipmentSelectionCheckboxGroupProps,
} from "./ControlledEquipmentSelectionCheckboxGroup.tsx";

type EquipmentGroupProps = Pick<ControlledEquipmentSelectionCheckboxGroupProps, "name" | "control">;

const EquipmentGroup: FC<EquipmentGroupProps> = (props) => {
  const [searchParams] = useSearchParams();

  const bookingDate = useMemo(() => {
    const startDate = convertStingToDate(searchParams.get("d"));
    const time = searchParams.get("t");
    startDate?.setHours(Number(time?.split(":")[0]));
    startDate?.setMinutes(Number(time?.split(":")[1]));

    if (!startDate) {
      return {
        startDate: "",
        endDate: "",
      };
    }

    const endDate = addHours(startDate, Number(searchParams.get("r")));

    return {
      startDate: format(new Date(startDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
      endDate: format(new Date(endDate), "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'"),
    };
  }, [searchParams]);

  const { equipment, isFetching } = useEquipment(bookingDate);

  const options = useMemo(() => {
    const mappedResult = [];

    for (const [categoryName, equipments] of Object.entries(equipment)) {
      const categoryEquipment = {
        categoryName: categoryName as Category,
        equipments,
      };
      mappedResult.push(categoryEquipment);
    }

    return mappedResult;
  }, [equipment]);

  if (isFetching) {
    return (
      <Grid2 mt={2} container justifyContent="center">
        <CircularProgress color="secondary" />
      </Grid2>
    );
  }

  return <ControlledEquipmentSelectionCheckboxGroup options={options} {...props} />;
};

export default EquipmentGroup;
